import { render, staticRenderFns } from "./tblUpdateSuppliers.html?vue&type=template&id=0acf57c2&scoped=true&"
import script from "./tblUpdateSuppliers.ts?vue&type=script&lang=ts&"
export * from "./tblUpdateSuppliers.ts?vue&type=script&lang=ts&"
import style0 from "./tblUpdateSuppliers.scss?vue&type=style&index=0&id=0acf57c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf57c2",
  null
  
)

/* custom blocks */
import block0 from "./tblUpdateSuppliers.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Ftasks%2FtblUpdateSuppliers%2FtblUpdateSuppliers.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VImg,VRow,VTooltip})
